import React from "react";
import { Box } from "@mui/material";
export default function LinearBar({ value, color, noShadow }) {
  return (
    <Box
      sx={{
        height: "6px",
        width: "100%",
        position: "relative",
        borderRadius: "3px",
      }}
    >
      <Box
        sx={{
          boxShadow: noShadow ? "none" : `0px 1px 6px ${color}b2`,
          background: `${color} 0% 0% no-repeat padding-box`,
          width: value,
          height: "100%",
          borderRadius: "3px",
        }}
      ></Box>
      <Box
        sx={{
          borderRadius: "3px",
          backgroundColor: "#FFFFFF33",
          width: "100%",
          position: "absolute",
          top: "0px",
          height: "100%",
        }}
      ></Box>
    </Box>
  );
}
